/* eslint-disable camelcase */
/* eslint-disable padding-line-between-statements */
/* eslint-disable unicorn/filename-case */
import React, { useCallback, useContext,useState, useEffect } from 'react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import { LocaleService_TWIA } from 'twia-capability-locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss';
import { TWIAStandardizeButton, TWIAStandardizationStatus } from 'twia-capability-address-component';
import StandardAddressValidationUtil from '../../util/StandardAddressValidationUtil'
import metadata from './TWIAAddressComponent.metadata.json5';
import messages from '../../addressMessages.messages';
import addressControl from '../../util/addressControl';

function TWIAAddressComponent(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const authHeader = _.get(useAuthentication(), 'authHeader')
    // const { authHeader } = useAuthentication();
    const { addressVM, updatePolicyAddressVM, country, showErrors, findInvalidComponent, onValidate, companyType, isStandardizationDisabled, xPortal, isEcheck, onAddressEdit, isLossLocation } = props;
    const [primaryAddressVM, updateAddressVM] = useState(addressVM);
    const [regex, setRegex] = useState('');
    const [zipCodevalidationMsg, setZipCodeValidationMsg] = useState([]);
    const [cedexBureauMsg, setCedexBureauMsg] = useState([]);
    const [addressConfig, setAddressConfig] = useState();
    const [showAddressValidationStatus, setStatus] = useState(false);
    const [labels, setLabels] = useState([]);
    const [fields, setFields] = useState([]);
    const [pcfMode, setMode] = useState('');
    const [stateVisibility, setVisibility] = useState(false);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('TWIAAddressComponent');
    const [noMatchFound, setNoMatchFound] = useState(false);
    const countryCode = _.get(primaryAddressVM?.value, 'country');
    
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'TWIAAddressComponent');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        if(findInvalidComponent){
            findInvalidComponent(isComponentValid, 'TWIAAddressComponent');
        }
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        if( xPortal === 'CC') {
            updateAddressVM(addressVM);
        }
    }, [addressVM]);

    useEffect(() => {
        if( xPortal === 'CC') {
            if( _.get(primaryAddressVM?.value, 'country') === 'US') {
                if(primaryAddressVM.value?.addressVerifyStatusExt === 'validated' ){
                    _.set(primaryAddressVM, 'isValidated_Ext', true);
                    _.set(primaryAddressVM, 'mustStandardize_Ext', true);
                    updateAddressVM(primaryAddressVM);
                } else if (primaryAddressVM.value?.addressVerifyStatusExt === 'notvalidated' 
                || primaryAddressVM.value?.addressVerifyStatusExt === undefined || primaryAddressVM.value?.addressVerifyStatusExt === 'overridden') { //DE17215
                    _.set(primaryAddressVM, 'mustStandardize_Ext', true);
                    updateAddressVM(primaryAddressVM);
                }
            } else {
                _.set(primaryAddressVM, 'mustStandardize_Ext', false);
                updateAddressVM(primaryAddressVM);
            }
        }
    },[primaryAddressVM.value]);

    useEffect(() => {
        if( xPortal === 'CC') {
            const val = primaryAddressVM?.value || primaryAddressVM; //DE17215
            setNoMatchFound(val.addressStandResult?.noAddressMatchFound);
        }
    },[primaryAddressVM.value]);
    
    useEffect(() => {
        getAddressConfig(countryCode);
        setStatus(addressControl.showStatus(primaryAddressVM.value, xPortal));
        updatePolicyAddressVM(addressVM.value);
    }, [primaryAddressVM?.value, addressVM?.value]);  //DE17476

    const hideFields = [];

    const isVisible = (fieldName) => {
        let visible = fields.indexOf(fieldName) >= 0;
        if (hideFields) {
            visible = visible && !(_.includes(hideFields, fieldName) || _.includes(_.map(hideFields, (idx) => `${idx}Kanji`), fieldName));
        }
        return visible;
    };

    const getAddressConfig = useCallback(
        async (value) => {
            if(authHeader) {
            await LocaleService_TWIA.getLocal_TWIA(value, authHeader).then(
                (locale) => {
                    const jsonStr = locale.localeJSONStr;
                    const localeInfoJSON = JSON.parse(jsonStr);
                    setAddressConfig(localeInfoJSON.address);
                    setLabels(localeInfoJSON.address.fieldLabels);
                    setFields(localeInfoJSON.address.fieldNames)
                    setMode(locale.pcfMode);
                    setRegex(locale.postalCodeRegex);
                    setVisibility(true);
                }
            )
        }
        },
    
        []);
        
    const validateRegex = (idRegex, target) => {
        // eslint-disable-next-line security/detect-non-literal-regexp
        if(idRegex === undefined){
            return true
        }
        const regex = new RegExp(`^${idRegex}$`); //DE16011
    
        return regex.test(target);
    };
    
    const validateZipCode = useCallback(() => {
        const code = _.get(primaryAddressVM.value, 'postalCode');
        const isCodevalid = code === "" ? true : validateRegex(regex, code); //DE16011
        setZipCodeValidationMsg([]);
        if (!isCodevalid ){   
            setZipCodeValidationMsg([translator(messages.ZIPCodeValidationMessageTFPA)]); //DE16364
        }
        return '';
    }, [primaryAddressVM, regex]);

    //DE16032
    const stateVisible = (value) => {
        if (value === 'US' || value === 'CA' || value === 'AU' || value === 'JP' || value === 'DE') {
            setVisibility(true);
        } else {
        // reset state if not supported
            primaryAddressVM.state.value = null;
            setVisibility(false);
        }
        updateAddressVM(primaryAddressVM);
    };
    
    const onCountryChange = useCallback((value, path) => {
        _.set(primaryAddressVM, path, value);
        getAddressConfig(value);
        stateVisible(value); 
        updateAddressVM(primaryAddressVM);
        if(xPortal === 'CC'){
            if(value !== 'US') {
                _.set(primaryAddressVM.value, 'mustStandardize_Ext', false);
            } else {
                _.set(primaryAddressVM.value, 'mustStandardize_Ext', true);
                _.set(primaryAddressVM.value,'addressVerifyStatusExt','notvalidated');
            }
        } else {
            if(value !== 'US') {
                _.set(primaryAddressVM.value, 'mustStandardize_Ext', false);
            } else {
                if( !isEcheck ) {
                    _.set(primaryAddressVM.value, 'mustStandardize_Ext', true);
                    _.set(primaryAddressVM.value, 'isNotValidated_Ext', true);
                    _.set(primaryAddressVM.value, 'isOverridden_Ext', false);
                }
            }
        }
        const x = addressControl.showStatus(primaryAddressVM.value, xPortal);
        setStatus(x);
        addressControl.isStdBtnAvailable(primaryAddressVM.value, xPortal);
        _.set(primaryAddressVM.value, 'postalCode', '');
        _.set(primaryAddressVM.value, 'state', null);
        updateAddressVM(primaryAddressVM);
    }, [primaryAddressVM, updateAddressVM]);
    
    const writeValue = useCallback(
        (value, path) => {
            // DE16631 Setting validation message when user enters more than 2 characters.
            if (path === 'cedexbureau_Ext' && value.length > 2) {
                setCedexBureauMsg([translator(messages.cedexBureauMessage)]);
            }
            // to know if the address is changed
            if (path === 'addressLine1'
                || path === 'addressLine2'
                || path === 'city'
                || path === 'state'
                || path === 'county'
                ||path === 'postalCode'
                ||path === 'country')
            {
                    StandardAddressValidationUtil.setNotValidated(primaryAddressVM.value);
                    setStatus(addressControl.showStatus(primaryAddressVM.value, xPortal));
                    if(xPortal === 'CC') { 
                        _.set(primaryAddressVM.value,'addressVerifyStatusExt','notvalidated'); 
                    }
                    updateAddressVM(primaryAddressVM);
                    if(!isEcheck){
                        if (countryCode === 'US') {
                            onAddressEdit(true);
                        } else {
                            onAddressEdit(false);
                        }
                    }
            }
            _.set(primaryAddressVM, path, value);
            updatePolicyAddressVM(primaryAddressVM);
        }, [countryCode, isEcheck, onAddressEdit, primaryAddressVM, translator, 
            updatePolicyAddressVM, xPortal]
    );

    const handleStandardizationResponse =useCallback((value)=> {
        const val = primaryAddressVM?.value || primaryAddressVM; //DE17215
        if(xPortal === 'CC'){
            if(val.addressStandResult?.noAddressMatchFound === true || val.addressStandResult?.isSingleAddress === true) {
                setNoMatchFound(true);
            }
        } else {
            setNoMatchFound(value.noAddressMatchFound);
        }
       
    });

    const CEDEXBureau = _.get(primaryAddressVM, 'cedexbureau_Ext.value')

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        statusComponent: {
            primaryAddressVM: primaryAddressVM.value, status:showAddressValidationStatus,
            visible: showAddressValidationStatus && !isEcheck,
            isStandardizationDisabled, noMatchFound, xPortal
        },
        buttonComponent: {
            visible: !isEcheck,
            primaryAddressVM: primaryAddressVM?.value, 
            updatePrimaryAddressVM: updatePolicyAddressVM,
            authHeader, 
            companyType,
            isStandardizationDisabled,
            xPortal,
            standardizationResponse: handleStandardizationResponse,
            zipCodevalidationMsg
        },
        country: {  
            visible: !isLossLocation
        },
        defaultAddressContainer: {
            visible: pcfMode === 'default'
        },
        BigToSmallContainer: {
            visible: pcfMode === 'BigToSmall'
        },
        PostCodeBeforeCityContainer: {
            visible: pcfMode === 'PostCodeBeforeCity'
        },
        city: {
            visible: isVisible('City'),
            label: labels.city
        },
        state: {
            visible: isVisible('State') && stateVisibility, //16032
            placeholder: `-- Choose ${labels.state} --`,
            label: labels.state,
        },
        addressLine1: {
            visible: isVisible('AddressLine1'),
        },
        addressLine2: {
            visible: isVisible('AddressLine2'),
            label: isEcheck ? translator(messages.echeckAddressLine2) : translator(messages.addressLine2) // DE16425 
        },
        addressLine3: {
            visible: isVisible('AddressLine3'),
        },
        zipCode: {
            visible: isVisible('PostalCode'),
            label: labels.postalCode,
            onBlur: validateZipCode,
            validationMessages: zipCodevalidationMsg
        },
        PCBCcedex: {
            visible: isVisible('CEDEX'),
        },
        PCBCcedexBureau: {
            visible: isVisible('CEDEXBureau') && _.get(primaryAddressVM, 'cedex_Ext.value') === true,// DE16361
            validationMessages: CEDEXBureau?.length > 2 ? cedexBureauMsg : [] // DE16631
        },
        BTSzipCode: {
            visible: isVisible('PostalCode'),
            label: labels.postalCode,
            onBlur: validateZipCode,
            validationMessages: zipCodevalidationMsg
        },
        BTSstate: {
            visible: isVisible('State') && stateVisibility,
            placeholder: `-- Choose ${labels.state} --`,
            label: labels.state,
        },
        BTScity: {
            visible: isVisible('City'),
            label: labels.city
        },
        BTScityKanji: {
            visible: isVisible('CityKanji'),
        },
        BTSaddressLine1: {
            visible: isVisible('AddressLine1'),
        },
        BTSaddressLine2: {
            visible: isVisible('AddressLine2'),
        },
        PCBCaddressLine1: {
            visible: isVisible('AddressLine1'),
        },
        PCBCaddressLine2: {
            visible: isVisible('AddressLine2'),
        },
        PCBCaddressLine3: {
            visible: isVisible('AddressLine3'),
        },
        PCBCzipCode: {
            visible: isVisible('PostalCode'),
            label: labels.postalCode,
            onBlur: validateZipCode,
            validationMessages: zipCodevalidationMsg
        },
        PCBCcity: {
            visible: isVisible('City'),
            label: labels.city
        },
        PCBCstate: {
            visible: isVisible('State') && stateVisibility,
            placeholder: `-- Choose ${labels.state} --`,
            label: labels.state,
        },
    }
    const resolvers = {
        resolveClassNameMap: wizardStyles,
        resolveComponentMap: {
            standardizeButtonComponent: TWIAStandardizeButton,
            standardizeStatusComponent: TWIAStandardizationStatus
        },
        resolveCallbackMap: {
            handleCountryChange: onCountryChange,
        },
    }

    return (
        <ViewModelForm
                uiProps={metadata.pageContent}
                model={primaryAddressVM}
                overrideProps={overrideProps}
                onValueChange={writeValue}
                onModelChange={updateAddressVM}
                onValidationChange={setComponentValidation}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                showErrors={showErrors}
        />
    )
}

export default TWIAAddressComponent